import { get } from "@ember/object"
import { later, scheduleOnce } from "@ember/runloop"
import { handleError } from "cc-frontend/error-handling"
import Manager from "ember-sortable/utils/manager"

function timeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export async function hideSectionValues() {
  $(".week-grid").css("visibility", "hidden")
  $(`#lesson-section-${get(this, "model.id")}`)
    .parents(".js-draggable-z-index-parent")
    .css({
      "z-index": 999999999,
      position: "relative",
    })
  $("body").append(`
    <style type="text/css" class="-moving-section-style" id="section-style-${get(
      this,
      "model.id"
    )}">
      .lesson-section__body,
      .js-lesson-section__body {
        // visibility: hidden;
        max-height: 0;
        overflow: hidden;
        opacity: 0;
      }
      .js-lesson-card-wrapper{
        padding: 0.5625rem 0;
      }
      .lesson-sections__btn-add-lesson-card-to-bottom-wrapper,
      .lesson-sections__btn-add-lesson-card-to-bottom,
      .js-add-card-to-lesson-wrapper,
      .js-add-card-to-lesson{
        padding-top: 0;
        padding-bottom: 0;
        // visibility: hidden;
        max-height: 0;
        overflow: hidden;
        opacity: 0;
      }
    </style>
  `)
  $(".week-grid").css("visibility", "visible")
}

/**
 *
 * @param {MouseEvent} originalEvent
 */
export async function startSorting(originalEvent) {
  this.dragging.set("isDragging", true)
  this.beginMove()
  // this._sortableManager = null
  let startingMouseUpCount = this.mouseUpCount

  // $("body").animate({scrollTop: (top - clientY + 20)}, 500)

  // We wait 150 ms to see if we've let the mouse up
  later(async () => {
    // return if destroyed
    if (this.isDestroyed || this.isDestroying) return

    // return if we left the mouse up
    if (startingMouseUpCount !== this.mouseUpCount) {
      this.dragging.set("isDragging", false)
      return
    }

    $("body").addClass("is-dragging")
    // We have to hide the sections and then scroll to the new position
    if ($("body").hasClass("is-mobile") === false) {
      // Make the dragged card look like its being dragged
      let wrapper = originalEvent.target.closest(".js-lesson-card-wrapper")
      if (wrapper) wrapper.classList.add("sortable-dragging")
      // hide the section value
      await this.hideSectionValues()
      let { top, left } = this.$().offset()
      let clientY = originalEvent.clientY
      originalEvent.pageX = left
      originalEvent.pageY = top
      let newScrollTop = top - clientY + 20
      // This didn't work as it made moving things not line up, but conceptually, it has potential
      // if (newScrollTop < 0) {
      // $(".planbook-calendar__main").css({ "padding-top": newScrollTop * -1 })
      // }
      $(window).scrollTop(newScrollTop)
    }

    // We then give the browser a frame to catch up and we then measure
    // which the sortabl emanager does
    later(() => {
      if (this.isDestroyed || this.isDestroying) return
      this._sortableManager = new Manager({
        node: this,
        onComplete: (...args) => {
          try {
            this.completeSorting(...args)
          } catch (e) {
            handleError(e)
          }
        },
        onCancel: (...args) => {
          try {
            this.completeSorting(...args)
          } catch (e) {
            handleError(e)
          }
        },
      })

      this._sortableManager.start(originalEvent)
      // enable the dragging before the mouse moves
    }, 15)
  }, 150)
}

export function completeSorting(receiver, position) {
  // Take care of reshowing sections and such
  this.dragging.set("isDragging", false)
  cleanUpAndShowSections(get(this, "model.id"))

  // if we don't have a receiver or a card, we just return so we don't error
  if (this === undefined || receiver === undefined) {
    return
  }

  // If we call _super earlier, we lose access to _sortableManager
  this._super(...arguments)
  let offset = this._sortableManager === undefined ? 0 : this._sortableManager.gesture.clientY
  let id = get(this, "model.id")
  let model = this.sortableModel
  let oldParent = this.sortableParent.sortableModel
  let newParent = receiver.sortableModel
  let receiverContext = receiver.sortableContext

  this.onMove(model, { oldParent, newParent, position, receiverContext })

  // Since we've uncollapsed the items, we need to scroll to it.
  scrollToMovedItem(id, offset)
}

function cleanUpAndShowSections(cardId) {
  $(`.-moving-section-style`).remove()
  $(`.sortable-dragging`).removeClass("sortable-dragging")
  $("body").removeClass("is-dragging")
  // Make sure the lesson doesn't show above the day marker
  $(`#lesson-section-${cardId}`).parents(".js-draggable-z-index-parent").css({
    "z-index": 0,
    position: "relative",
  })
}

function scrollToMovedItem(id, offset) {
  scheduleOnce("afterRender", () => {
    later(() => {
      let $lessonSectionEl = $(`#lesson-section-${id}`)
      if ($lessonSectionEl) {
        let lessonSectionOffset = $lessonSectionEl.offset()
        if (lessonSectionOffset) {
          $(window).scrollTop(lessonSectionOffset.top - offset + 20) // 25 is so the cursor is at the card title
        } else {
          // Happens if we're dragging to a new lesson that triggers LESSON_FIRST_EDIT
        }
      }
      requestAnimationFrame(() => {
        $(".week-grid").css({ visibility: "visible", opacity: 1 })
      })
    }, 0)
  })
}
